import React from 'react';

import ManageActivitiesV2 from '../components/assignment_flow/manage_activities_v2/manage_activities_v2';
import DemoAccountContextProvider from '../contexts/DemoAccountContextProvider';

const ManageActivitiesV2AppClient = ({ isDemo = false, ...props }) => (
  <DemoAccountContextProvider isDemo={isDemo}>
    <ManageActivitiesV2 {...props} />
  </DemoAccountContextProvider>
);

export default ManageActivitiesV2AppClient;
